// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_99-3";
export var contentContainer = "_99-0";
export var editorContainer = "_99-1";
export var quillInputForm = "_99-2";
export var zoneDivider = "_99-4";